import { useTranslation } from 'react-i18next';



export const ErrorPage = () => {
	const { t } = useTranslation('global');

	return (
		<div className="app-error-page">
			
			<h1>{t('authentication.failedPage.text')}</h1>

		</div>
	);
};